import VerificationTab from './container'

export default VerificationTab